import React, { useState, useEffect } from "react";
import API from "api/endpoints";
import { softwarecol } from "Pages/EmployeeDashboard/EmployeeAssets/TableColumns";
import { hardwarecol } from "Pages/EmployeeDashboard/EmployeeAssets/TableColumns";
import { formatDateTime } from "Common/DateTimeFormat";
import axiosInstance from "api/axiosInstance";

function EmployeeAssetsService() {
  const employeeId = localStorage.getItem("personalId");
  const [activeIndex, setActiveIndex] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [datahardwareSource, setDatahardwareSource] = useState([]);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    fetchData();
    fetchHardwareData();
  }, []);

  async function fetchData() {
    try {
      if (!employeeId) {
        console.error("No personalId found in localStorage");
        return;
      }

      // Fetch software assets by personalId
      const response = await axiosInstance.get(API.softwareAssets.getEmployeeAssets(employeeId));

      const userData = response.data;

      // Generate rows based on the fetched assets data
      const updatedRows = userData.softwareAssets.map((asset) => {
        return {
          key: asset.id.toString(),
          Category: asset.category || "N/A",
          Description: asset.description || "N/A",
          Provider: asset.provider || "N/A",
          Licensekey: asset.licenseKey || "N/A",
          SubscriptionDate: <span>{formatDateTime(asset.subscriptionDate)}</span>,
          ExpiryDate: <span>{formatDateTime(asset.expiryDate)}</span>,
          AssetsCost: asset.assetsCost || 0,
          Notes: asset.notes || "N/A",
        };
      });
      setDataSource(updatedRows);
    } catch (error) {
      console.error("Error fetching software data:", error);
    }
  }

  async function fetchHardwareData() {
    try {
      if (!employeeId) {
        console.error("No personalId found in localStorage");
        return;
      }

      // Fetch hardware assets by personalId
      const response = await axiosInstance.get(API.hardwareAssets.getEmployeeAssets(employeeId));

      const userData = response.data;

      // Generate rows based on the fetched assets data
      const updatedRows = (userData.hardwareAssets || []).map((asset) => {
        return {
          key: asset.hardwareAssetsId?.toString() || Math.random().toString(),
          Category: asset.category || "N/A",
          Description: asset.description || "N/A",
          Serial: asset.serial || "N/A",
          DateLoaned: <span>{formatDateTime(asset.dateLoaned)}</span>,
          DateReturned: <span>{formatDateTime(asset.dateReturned)}</span>,
          AssetsCost: asset.assetsCost || 0,
          Notes: asset.notes || "N/A",
        };
      });

      setDatahardwareSource(updatedRows);
    } catch (error) {
      console.error("Error fetching data:", error);
      // You might want to add error handling UI here
    }
  }

  return { softwarecol, hardwarecol, dataSource, datahardwareSource, toggleAccordion, activeIndex };
}

export default EmployeeAssetsService;
